import {
	CheckboxField,
	EntityDrawerProps,
	FCC,
	FormDrawer,
	FormDrawerContent,
	SingleSelectField,
	TextField,
	isEmail,
} from "@dgs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ALL_CONTACT_EMAIL, ContactEmailFormState } from "../../shared/types/contactEmail";

interface ContactEmailDrawerProps extends EntityDrawerProps<ContactEmailFormState> {
	hasUser: boolean;
}

export const ContactEmailDrawer: FCC<ContactEmailDrawerProps> = ({ hasUser, children, initialValues, ...props }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: ContactEmailFormState) => {
			const errors: { [K in keyof ContactEmailFormState]?: any } = {};

			if (!values.email) {
				errors.email = t("Required field");
			} else if (!isEmail(values.email)) {
				errors.email = t("Invalid email address");
			}

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			validate={validate}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="email" label={t("Email")} disabled={initialValues.isPrimary && hasUser} required />
					<SingleSelectField
						options={ALL_CONTACT_EMAIL.map((e) => ({ label: t(e), value: e }))}
						getLabel={(x) => x.label}
						getValue={(x) => x.value}
						name="type"
						label={t("Type")}
						clearable={false}
						disabled={initialValues.isPrimary && hasUser}
					/>
					<CheckboxField label={t("Mark as primary")} name="isPrimary" disabled={initialValues.isPrimary || hasUser} />
					{children}
				</FormDrawerContent>
			)}
		/>
	);
};
